import React from 'react';

function PrintSVG() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 1C4 0.447715 4.44772 0 5 0H15C15.5523 0 16 0.447715 16 1V6H17C18.6569 6 20 7.34315 20 9V15C20 16.6569 18.6569 18 17 18H16V19C16 19.5523 15.5523 20 15 20H5C4.44772 20 4 19.5523 4 19V18H3C1.34315 18 0 16.6569 0 15V9C0 7.34315 1.34315 6 3 6H4V1ZM4 16V13C4 12.4477 4.44772 12 5 12H15C15.5523 12 16 12.4477 16 13V16H17C17.5523 16 18 15.5523 18 15V9C18 8.44772 17.5523 8 17 8H3C2.44772 8 2 8.44772 2 9V15C2 15.5523 2.44772 16 3 16H4ZM14 2V6H6V2H14ZM14 18H6V14H14V18Z"
      />
    </svg>
  );
}

export default PrintSVG;
